/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Own_CodeInputs */

const en_us2_invite_own_code = /** @type {(inputs: Invite_Own_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is your own invite.`)
};

const pt_br2_invite_own_code = /** @type {(inputs: Invite_Own_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse é o seu próprio convite.`)
};

const pt_pt2_invite_own_code = /** @type {(inputs: Invite_Own_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse é o seu próprio convite.`)
};

/** @type {(inputs: Invite_Own_CodeInputs) => LocalizedString} */
const es_419_invite_own_code = en_us2_invite_own_code;

/** @type {(inputs: Invite_Own_CodeInputs) => LocalizedString} */
const fr_fr2_invite_own_code = en_us2_invite_own_code;

/** @type {(inputs: Invite_Own_CodeInputs) => LocalizedString} */
const de_de2_invite_own_code = en_us2_invite_own_code;

/** @type {(inputs: Invite_Own_CodeInputs) => LocalizedString} */
const it_it2_invite_own_code = en_us2_invite_own_code;

/**
* | output |
* | --- |
* | "That is your own invite." |
*
* @param {Invite_Own_CodeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_own_code = /** @type {((inputs?: Invite_Own_CodeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Own_CodeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_own_code(inputs)
	if (locale === "es-419") return es_419_invite_own_code(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_own_code(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_own_code(inputs)
	if (locale === "de-DE") return de_de2_invite_own_code(inputs)
	if (locale === "it-IT") return it_it2_invite_own_code(inputs)
	return en_us2_invite_own_code(inputs)
});
export { invite_own_code as "invite.own_code" }